import type { Environment } from '@/shared/types/other.types'

export const getQicTravelKitUrl = (environment: Environment, locale: string) => {
  const env = environment === 'production' ? 'prod' : 'test'
  const localeSuffix = locale === 'ar' ? 'ar' : 'eng'
  return `https://calendar.qic.online/${locale}?utm_medium=referral&utm_source=website&utm_campaign=visitors_success_screen&utm_content=banner_${env}_${localeSuffix}`
}
